import { GroupStyled } from './styles'

import NotificationUi from '@/common/components/Notifications/NotificationUi/NotificationUi'

import { useAppSelector } from '@/core/store/hooks'

const NotificationsUiList: React.FC = () => {
  const notificationsList = useAppSelector(
    (state) => state.NotificationsReducer.notificationsList,
  )

  return (
    <GroupStyled>
      {notificationsList.map((item) => (
        <NotificationUi
          key={`alert-${item.id}`}
          id={item.id}
          message={item.message}
          reiniciadoEn={item.reiniciadoEn}
          repeticiones={item.repeticiones}
          style={item.style}
          title={item.title}
        />
      ))}
    </GroupStyled>
  )
}

export default NotificationsUiList
